/*@ngInject*/
const AddDeleteRepeatingFormConfigRepository = function (baseRepository) {

    angular.extend(this, baseRepository);

    this.getAddDeleteConfigByFormSummaryInstanceId = function (formId, formSummaryInstanceId) {
        let url = '/rest/Form/addDeleteRepeatingFormConfig',
            config = {
                params: {
                    parentFormId: formId,
                    repeatingFormId: formSummaryInstanceId
                }
            };

        return this.get(url, config);
    };

    this.getAddDeleteConfigByFormSummaryGridFieldName = function (formId, formSummaryGridFieldName) {
        let url = '/rest/Form/addDeleteRepeatingFormConfig',
            config = {
                params: {
                    parentFormId: formId,
                    formSummaryGridFieldName: formSummaryGridFieldName
                }
            };

        return this.get(url, config);
    };
};

angular.module('umFormViewer')
    .service('addDeleteRepeatingFormConfigRepository', AddDeleteRepeatingFormConfigRepository);
